// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LinkedinFilledSvg from "@ant-design/icons-svg/es/asn/LinkedinFilled";
import AntdIcon from '../components/AntdIcon';

var LinkedinFilled = function LinkedinFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: LinkedinFilledSvg
  }));
};

LinkedinFilled.displayName = 'LinkedinFilled';
export default React.forwardRef(LinkedinFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/LinkedinFilled.js
// module id = 1423
// module chunks = 0